import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { LoginService } from '~login/services/login.service';
import { LoginActions } from '~login/store/login.actions';

export const AuthGuard: CanActivateFn = ( ) => {
    const loginService: LoginService = inject(LoginService);
    const isLoggedIn: boolean = loginService.isLoggedIn();
    const router: Router = inject(Router);
    const store: Store = inject(Store);

    if (!isLoggedIn) {
        console.error('Token is expired or null');
        Promise.resolve().then((): Promise<void> => router.navigate(['auth']).then(() => store.dispatch(LoginActions.logout())));
    }

    return isLoggedIn;
};
